// extracted by mini-css-extract-plugin
module.exports = {"section":"FilterSection_section__mK9CG","title":"FilterSection_title___qKgt","bold":"FilterSection_bold__Qdtey","grid":"FilterSection_grid__0FFDp"};